import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';

import { apiEndpoint } from '../../constants/endpoints.const';
import { Configuration } from '../../interfaces/api/configuration';

@Service()
export class PreferencesApi {
  http = inject(HttpClient);

  public getPreferencesFromApi(tenant: number): Observable<Configuration> {
    return this.http.get<Configuration>(`${apiEndpoint}/users/preferences/byheader/${tenant}`);
  }

  public updatePreferences(tenant: number, userPreferences: Configuration | null): Observable<Configuration> {
    if (userPreferences !== null) {
      return this.http.put<Configuration>(`${apiEndpoint}/users/preferences/byheader/${tenant}`, userPreferences);
    }
    return new Observable<Configuration>();
  }
}
